import { Stack } from "@mantine/core";
import { Radio as RadioComp } from "react-hook-form-mantine";
import { Data } from "shared/types/forms";
import styles from "./index.module.scss";

type Props = {
  name: string;
  data: Data[];
  label?: string;
  required?: boolean;
  control: any;
};

const rules = (required?: boolean) => ({
  required: required
    ? {
        value: true,
        message: "Веберите один из вариантов",
      }
    : {},
});

export const Radio = ({ data, required, ...otherProps }: Props) => {
  return (
    <RadioComp.Group
      className={styles.wrapper}
      rules={rules(required) as any}
      required
      {...otherProps}
    >
      <Stack>
        {data!.map(({ value, label }) => (
          <RadioComp.Item
            iconColor={"dark.9"}
            className={styles.item}
            label={label}
            value={value}
            key={value}
          />
        ))}
      </Stack>
    </RadioComp.Group>
  );
};
